// +----------------------------------------------------------------------
// | 本地登录态存储（username + token 双 Header 方案）
// | token 存 localStorage，刷新页面不掉登录；退出时清空
// +----------------------------------------------------------------------

const AUTH_KEY = 'xiangxiang_auth';

/**
 * 读取登录态
 * @returns {{username: string, token: string, user: object}|null}
 */
export function getAuth() {
  try {
    const raw = window.localStorage.getItem(AUTH_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || !data.username || !data.token) return null;
    return data;
  } catch (e) {
    return null;
  }
}

/**
 * 写入登录态
 * @param {{username:string, token:string, user?:object}} payload
 */
export function setAuth(payload) {
  const data = {
    username: payload.username,
    token: payload.token,
    user: payload.user || null,
  };
  window.localStorage.setItem(AUTH_KEY, JSON.stringify(data));
  return data;
}

/**
 * 局部更新用户信息（不改 token）
 */
export function updateAuthUser(user) {
  const current = getAuth();
  if (!current) return null;
  const next = { ...current, user: { ...(current.user || {}), ...user } };
  window.localStorage.setItem(AUTH_KEY, JSON.stringify(next));
  return next;
}

export function clearAuth() {
  window.localStorage.removeItem(AUTH_KEY);
}

export function isLoggedIn() {
  return !!getAuth();
}
